import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { E as u, S as p } from "./icons.types-0722eef5.js";
function g({ title: o, titleId: l, size: r, width: s, height: n, extended: i = !1, ...f }) {
  const a = i ? u : p, h = r ? a[r] : s || a[i ? "s" : "l"], d = r ? a[r] : n || a[i ? "s" : "l"];
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 22 22",
      width: h,
      height: d,
      "aria-labelledby": l,
      ...f,
      children: [
        o ? /* @__PURE__ */ e("title", { id: l, children: o }) : null,
        /* @__PURE__ */ t("g", { filter: "url(#status_on_svg__a)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              fill: "#008200",
              d: "M11 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              stroke: "#015E01",
              strokeWidth: 0.5,
              d: "M11 14.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"
            }
          )
        ] }),
        /* @__PURE__ */ e("g", { filter: "url(#status_on_svg__b)", children: /* @__PURE__ */ e(
          "path",
          {
            fill: "#008200",
            d: "M11 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
          }
        ) }),
        /* @__PURE__ */ e(
          "path",
          {
            fill: "#A5DFA5",
            d: "M10 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
          }
        ),
        /* @__PURE__ */ t("defs", { children: [
          /* @__PURE__ */ t(
            "filter",
            {
              id: "status_on_svg__a",
              width: 17,
              height: 17,
              x: 2.5,
              y: 2.5,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e(
                  "feFlood",
                  {
                    floodOpacity: 0,
                    result: "BackgroundImageFix"
                  }
                ),
                /* @__PURE__ */ e(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ e("feOffset", {}),
                /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: 2.5 }),
                /* @__PURE__ */ e(
                  "feComposite",
                  {
                    in2: "hardAlpha",
                    operator: "out"
                  }
                ),
                /* @__PURE__ */ e("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0 0 0 0 0 0.3 0" }),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_6011_47860"
                  }
                ),
                /* @__PURE__ */ e(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ e("feOffset", {}),
                /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: 0.5 }),
                /* @__PURE__ */ e(
                  "feComposite",
                  {
                    in2: "hardAlpha",
                    operator: "out"
                  }
                ),
                /* @__PURE__ */ e("feColorMatrix", { values: "0 0 0 0 0.12125 0 0 0 0 0.808333 0 0 0 0 0.12125 0 0 0 1 0" }),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    in2: "effect1_dropShadow_6011_47860",
                    result: "effect2_dropShadow_6011_47860"
                  }
                ),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect2_dropShadow_6011_47860",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t(
            "filter",
            {
              id: "status_on_svg__b",
              width: 6,
              height: 6,
              x: 8,
              y: 8,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e(
                  "feFlood",
                  {
                    floodOpacity: 0,
                    result: "BackgroundImageFix"
                  }
                ),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ e(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ e("feOffset", {}),
                /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: 2 }),
                /* @__PURE__ */ e(
                  "feComposite",
                  {
                    in2: "hardAlpha",
                    k2: -1,
                    k3: 1,
                    operator: "arithmetic"
                  }
                ),
                /* @__PURE__ */ e("feColorMatrix", { values: "0 0 0 0 0.72 0 0 0 0 0.9 0 0 0 0 0.72 0 0 0 1 0" }),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    in2: "shape",
                    result: "effect1_innerShadow_6011_47860"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
export {
  g as StatusOn
};
